import { styled } from "styled-components";
import { RxCross2 } from 'react-icons/rx';
import { MdErrorOutline } from 'react-icons/md';
import { useState } from "react";

export default function LoadingError() {
    const [hideError, setHideError] = useState(false);
    return(
        !hideError && 
        <Wrapper>
            <div className="error-container">
                <MdErrorOutline size='2.5rem' />
                <span>An error occured while fetching data!</span>
            </div>
            <RxCross2 size='2.2rem' className="close-btn" onClick={() => setHideError(true)} />
        </Wrapper>
    );
}

const Wrapper = styled.div`
    background-color: #FFc0c0;
    width: 50%;
    margin: auto;
    margin-top: 2rem;
    padding: 1.5rem 3rem;
    font-size: 1.8rem;
    letter-spacing: 1.2px;
    color: #DF323C;
    border-radius: 2px;
    border: 1px solid ${({theme}) => theme.colors.error};
    display: flex;
    align-items: center;
    justify-content: space-between;
    .error-container {
        display: flex;
        gap: 1rem;
        align-items: center;
    }
    .close-btn {
        color: #f5f5f5;
        cursor: pointer;
        transition: 0.3s;
    }
    .close-btn:hover {
        color: #DF323C;
    }
`;